import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import gsap from 'gsap';

$(document).ready(function() {
    const swiper = new Swiper('.about-slider', {
        loop: true,
        centeredSlides: true,
        modules: [Autoplay, Pagination, Navigation],
        autoplay: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
                autoplay: false,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-navigation__next',
                    prevEl: '.swiper-navigation__prev',
                  }
            },
            1024: {
                slidesPerView: 3,
                speed: 3500,
                loop: true,
                centeredSlides: true,
                pagination: false,
                navigation: false
            }
        },
        on: {
            slideChangeTransitionStart: function(s) {
                if(window.innerWidth > 1023) {
                    const animationDuration = 1.5;
                    const slideAnimationElements = '.slide__description';
                    const slideAnimationHeading = '.slide__heading';

                    // OUT
                    const lastSlide = s.slides[s.activeIndex - 1];
                    const lastContentElements = Array.from(lastSlide.querySelectorAll(slideAnimationElements)).reverse();
                    const lastContentHeading = Array.from(lastSlide.querySelectorAll(slideAnimationHeading)).reverse();
                    gsap.fromTo(lastSlide, { scale: 1, opacity: 1 }, { scale: .6, opacity: .5, duration: animationDuration, delay: animationDuration / 4, ease: 'power3.in'});
                    gsap.fromTo(lastContentHeading, { scale: 1 }, { scale: 1.4, duration: animationDuration, delay: animationDuration / 4, ease: 'power3.in'});
                    gsap.fromTo(lastContentElements, { opacity: 1 }, { opacity: 0, duration: animationDuration, delay: animationDuration / 4, ease: 'power3.in'});

                    // IN
                    const nextSlide = s.slides[s.activeIndex];
                    const nextContentElements = Array.from(nextSlide.querySelectorAll(slideAnimationElements)).reverse();
                    const nextContentHeading = Array.from(nextSlide.querySelectorAll(slideAnimationHeading)).reverse();
                    gsap.fromTo(nextSlide, { scale: .6 }, { scale: 1, duration: animationDuration, delay: animationDuration / 2,  ease: 'power4.out'});
                    gsap.fromTo(nextContentHeading, { scale: 1.4 }, { scale: 1, duration: animationDuration, delay: animationDuration / 2, ease: 'power4.out'});
                    gsap.fromTo(nextContentElements, { opacity: 0 }, { opacity: 1, duration: animationDuration, delay: animationDuration, ease: 'power4.out'});
                }
            }
        }
    });

    const slider_description= $('.about-slider .swiper-slide .slide__description');
    const max_height = 150;

    slider_description.each(function() {
        
        if($(this).children().height() > max_height) {
            $(this).toggleClass('collapsed');
            $(this).find('.expand-arrow').show();
        }
    })        
});

$(document).on('click', '.about-slider .swiper-slide .slide__description .expand-arrow', function(e) {
    $(e.target.closest('.slide__description')).toggleClass('collapsed');
    $(e.target.closest('.slide__description')).toggleClass('expanded');
})
